import { Link } from 'react-router-dom';

export default function VRIntroSection() {
  return (
    <section className="bg-[#F5F1EB] py-20 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">

        {/* Quick Answer Box */}
        <div className="bg-white border border-[#C9A96E]/35 rounded-2xl px-8 py-7 mb-14">
          <div className="flex items-start gap-4">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
              <i className="ri-lightbulb-line text-[#2D4A3E] text-sm" />
            </div>
            <div>
              <p className="text-[#2D4A3E] font-jost text-xs tracking-[0.2em] uppercase font-semibold mb-2">Quick Answer</p>
              <p className="text-[#1A1A18] font-jost text-sm leading-relaxed">
                If you are looking for the best vacation rentals in Highlands, NC, <strong className="font-medium">Glen Falls Luxury Cabin</strong> stands out for its privacy, luxury feel, location near town and waterfalls, and strong guest reviews. It holds a 5.0-star Airbnb Guest Favorite rating — one of the highest in the area. That said, Highlands has several other well-regarded options worth considering depending on your group size, budget, and priorities.
              </p>
            </div>
          </div>
        </div>

        {/* Main intro */}
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-5">/ About This Guide</p>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#1A1A18] font-light mb-8 leading-tight">
            Finding the Right Place<br /><em className="italic">to Stay in Highlands</em>
          </h2>
        </div>

        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
          Searching for vacation rentals in Highlands, NC means stepping into one of the most scenic corners of the Blue Ridge Mountains. Highlands sits at over 4,000 feet in elevation — which means genuinely cool summers, dramatic mountain views, and a landscape filled with waterfalls, hiking trails, and dense hardwood forest. The town itself is small but remarkably well-developed, with acclaimed restaurants, art galleries, boutique shops, and a lively Saturday Farmers Market all within a walkable downtown.
        </p>
        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-5">
          The rental market here reflects the character of the town: most places to stay in Highlands, NC lean toward the higher end — private cabins, mountain homes, and luxury retreats rather than generic hotel rooms. That&apos;s part of what makes Highlands such a compelling destination. Whether you&apos;re planning a romantic weekend, a family trip, or a longer mountain escape, the right cabin here can genuinely make the trip.
        </p>
        <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-8">
          This guide covers the top vacation rentals in Highlands, NC based on real guest ratings, location, and overall experience. We&apos;ve included only real properties with verified listings — no invented names, no made-up reviews. Glen Falls Luxury Cabin earns the top spot, but we&apos;ve included several other strong options so you can find the right fit for your trip. For a broader look at{' '}
          <Link to="/cabins-in-highlands-nc" className="text-[#2D4A3E] underline underline-offset-2 hover:text-[#1e3329] transition-colors">
            cabins in Highlands, NC
          </Link>
          , see our dedicated guide.
        </p>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: 'ri-landscape-line', label: '4,118 ft', sub: 'Elevation' },
            { icon: 'ri-drop-line', label: '3+ Waterfalls', sub: 'Within 10 min' },
            { icon: 'ri-restaurant-line', label: 'Downtown', sub: '5 min from most rentals' },
            { icon: 'ri-temp-cold-line', label: 'Cool Summers', sub: '10–15°F cooler' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white rounded-xl p-5 text-center">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EDE8E0] mx-auto mb-3">
                <i className={`${stat.icon} text-[#2D4A3E] text-sm`} />
              </div>
              <p className="font-cormorant text-xl text-[#1A1A18] font-medium">{stat.label}</p>
              <p className="text-[#9C9890] text-xs font-jost mt-1">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
